<div class="dialog-header center">
  <h2 class="dialog-title">Введите ваш город 📍</h2>
  <app-custom-button
    (buttonClick)="close()"
    [iconName]="'close'"
    [variant]="'close'"
  ></app-custom-button>
</div>
<mat-dialog-content>
  <!-- <p>Выберите ваш город для более точного отображения мероприятий на карте</p> -->

  <form (ngSubmit)="onSubmit()">
    <app-dadata-address
      [formControl]="cityControl"
      type="city"
      placeholder="Начните вводить название города"
    >
    </app-dadata-address>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <app-custom-button
    [disabled]="!cityControl.value"
    [label]="'Сохранить'"
    (buttonClick)="onSubmit()"
  ></app-custom-button>
</mat-dialog-actions>
